import { ServiceRequest } from "../utils/service-request"
import { DASHBOARD_PATH } from "../utils/api-routes"

class DashboardService {
    constructor() {
        this.request = new ServiceRequest()
    }

    loadDashboardChart = () => {
        return this.request.get(`${DASHBOARD_PATH}`, undefined, true)
    }
}

export default DashboardService
